module.exports = __webpack_public_path__ + "img/1620.5903c919.png";